import * as React from "react";
const SvgLockLocked20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 1a5 5 0 0 0-5 5v2H2v11h16V8h-3V6a5 5 0 0 0-5-5Zm3 7V6a3 3 0 1 0-6 0v2h6Zm-7 2H4v7h12v-7H6Z",
      clipRule: "evenodd"
    })
  );
export default SvgLockLocked20Px;
